var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qianshuIcon"},[_c('div',{staticClass:"qianshuIcon_r",style:(`--color:${_vm.item.color};--bg:${_vm.item.color + '0D'}`)},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }